import { t } from '@lingui/core/macro';
import { SubscriptionPeriod } from 'modules/organizer/domain/interfaces/active-tournament-plan';

export function formatSubscriptionPeriod(period: SubscriptionPeriod): string {
  return period === 'YEARLY'
    ? t({ message: 'год', comment: 'Период тарифа: цена за год' })
    : t({ message: 'месяц', comment: 'Период тарифа: цена за месяц' });
}
